module.exports = __webpack_public_path__ + "static/media/export.0ba7a16c.svg";